import React, { Component } from "react";
import {
  Container,
  Row,
  Col,
  Breadcrumb,
  BreadcrumbItem,
  Button,
} from "reactstrap";
import Header from "../components/Header";
import Footer from "../components/Footer";
import CartItems from "../components/cartItems";
import {
  setCookie,
  getCookie,
  eraseCookie,
  setLocalStorage,
  getLocalStorage,
} from "../global/browserFunctions";



class Cart extends Component {
  constructor(props) {
      super(props);
      this.state={
          cartCount: getCookie('cartCount') || 0
      }
    if (!getCookie("log")) {
      this.GoToPage("/");
    }
    document.title = "Cart";
  }

  GoToPage(path) {
    this.props.history.push(path);
  }

  render() {
    return (
      <React.Fragment>
        <Header history={this.props.history} />
        <section className="hero py-6">
                <Container>
                    <Breadcrumb className="pl-0">
                        <BreadcrumbItem><a href="/index">Home</a></BreadcrumbItem>
                        <BreadcrumbItem active>Shopping cart</BreadcrumbItem>
                    </Breadcrumb>
                    <div className="hero-content">
                        <h1 className="hero-heading">Shopping cart</h1>
                        {/* <div>
                            <p className="lead text-muted">You have {this.state.cartCount} items in your cart.  {this.state.cartCount== (0 || "0") ? (<span className="lead text-muted">Go to our <a href="/home">Home Page</a></span>): ( <p className="lead text-muted"></p>)}</p>
                        </div> */}
                    </div>
                </Container>
            </section>

            <section>
                <Container>
                    <Row className="mb-5">
                            <CartItems history={this.props.history} />  
                    </Row>
                </Container>
            </section>
        <Footer />
      </React.Fragment>
    );
  }
}
export default Cart;
